import {
  UserManager,
  WebStorageStateStore,
  type UserManagerSettings,
} from "oidc-client-ts";
import type { PublicRuntimeConfig } from "@/lib/config/publicRuntimeConfig";

const buildCognitoUserManagerSettings = (
  config: PublicRuntimeConfig,
): UserManagerSettings => ({
  authority: config.cognitoAuthority,
  client_id: config.cognitoClientId,
  redirect_uri: window.location.origin,
  response_type: config.cognitoResponseType,
  scope: config.cognitoScope,
  automaticSilentRenew: true,
  monitorSession: false,
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
});

let userManager: UserManager | null = null;

/** One manager per page: silent renew timers and events must not be duplicated. */
export const getCognitoUserManager = (
  config: PublicRuntimeConfig,
): UserManager => {
  userManager ??= new UserManager(buildCognitoUserManagerSettings(config));
  return userManager;
};

/** Test helper: drop the memoized manager. */
export const resetCognitoUserManagerForTests = (): void => {
  userManager?.stopSilentRenew();
  userManager = null;
};
